
        var result = require("!!../../../../node_modules/css-loader/index.js!./treatment.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/settings/settings-cashreg/treatment.component.css
// module id = 2331
// module chunks = 1